// src/redux/apis/loginAPI.ts

export const fakeLogin = async (data: { email_phone: string; password: string }) => {
  return new Promise<{ token: string; user: { email: string; name: string } }>((resolve, reject) => {
    setTimeout(() => {
      if (data.email_phone === "admin@example.com" && data.password === "admin123") {
        resolve({ 
          token: "fake_jwt_token",
          user: {
            email: data.email_phone,
            name: "Admin User"
          }
        });
      } else {
        reject("Invalid email or password");
      }
    }, 1000);
  });
};
